import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { APIV2 } from "services/ApiServiceV2";

const CryptoJS = require("crypto-js");
const secret = "de7a784421b80444f87601ebc76dc63ec989c55e";

const getSignature = (method, endpoint, payload) => {
    let requestString = method + endpoint + JSON.stringify(payload);
    let hash = CryptoJS.HmacSHA256(requestString, secret);
    let signature = CryptoJS.enc.Base64.stringify(hash);
    return signature;
};

export const getUserDetails = createAsyncThunk("profile/getUserDetails", async (arg, thunkAPI) => {
    return await APIV2(
        `getUserDetails?userId=${
            thunkAPI.getState().AuthReducer.userId || thunkAPI.getState().StoredutilsSlice?.guestUserId
        }`,
        "GET",
        arg,
        "NODE"
    )
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getUserSavedCards = createAsyncThunk("profile/getUserSavedCards", async (arg, thunkAPI) => {
    const signature = getSignature("GET", "/v1/payment/bank-details", {});
    const dynamicHeaders = {
        "x-access-sign": signature,
    };
    return await APIV2(
        `/v1/payment/bank-details?userId=${thunkAPI.getState().AuthReducer.userId}`,
        "GET",
        {},
        "JAVA",
        null,
        dynamicHeaders
    ).then((res) => {
        return res;
    });
});

export const deleteUserSavedCard = createAsyncThunk("profile/deleteUserSavedCard", async (arg, thunkAPI) => {
    const signature = getSignature("DELETE", "/v1/payment/bank-details", arg);
    const dynamicHeaders = {
        "x-access-sign": signature,
    };
    return await APIV2(`/v1/payment/bank-details`, "DELETE", arg, "JAVA", null, dynamicHeaders).then((res) => {
        return res;
    });
});

export const saveUserCard = createAsyncThunk("profile/saveUserCard", async (arg, thunkAPI) => {
    const signature = getSignature("POST", "/v1/payment/store-card", arg);
    const dynamicHeaders = {
        "x-access-sign": signature,
    };
    return await APIV2(`/v1/payment/store-card`, "POST", arg, "JAVA", null, dynamicHeaders)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err.response;
        });
});

export const updateUserProfile = createAsyncThunk("profile/updateUserProfile", async (arg, thunkAPI) => {
    return await APIV2(`userProfile`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const newsLetterSubscribe = createAsyncThunk("profile/newsLetterSubscribe", async (arg, thunkAPI) => {
    return await APIV2(`subscribe`, "POST", arg, "NODE")
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
});

export const getPrefQns = createAsyncThunk("profile/getPrefQns", async (arg, thunkAPI) => {
    return await APIV2(
        `/preferences/questions?userId=${
            thunkAPI.getState().AuthReducer.userId || thunkAPI.getState().StoredutilsSlice?.guestUserId
        }`,
        "GET",
        {},
        "NODE"
    ).then((res) => {
        return res;
    });
});

export const savePrefAns = createAsyncThunk("profile/savePrefAns", async (arg, thunkAPI) => {
    return await APIV2(`/preferences/questions`, "POST", arg, "NODE").then((res) => {
        return res;
    });
});

export const getPrefAns = createAsyncThunk("profile/getPrefAns", async (arg, thunkAPI) => {
    return await APIV2(`/user/preferences?userId=${arg?.userId}`, "GET", arg, "NODE").then((res) => {
        return res;
    });
});

let initialState = {
    profileData: null,
    _helpModalRef: null,
    isSubscribed: null,
    cards: [],
};

export const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setUserId: (state, action) => {
            state.userId = action.payload;
        },
        setProfileData: (state, action) => {
            state.profileData = action.payload;
        },
        setHelpModalRef: (state, action) => {
            state._helpModalRef = action.payload;
        },
        resetProfileSlice: (state) => {
            state.profileData = null;
            state._helpModalRef = null;
            state.isSubscribed = null;
        },
        setSavedCards: (state, action) => {
            state.cards = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUserDetails.pending, (state, action) => {})
            .addCase(getUserDetails.fulfilled, (state, action) => {
                if ([200].includes(action.payload?.data?.data?.statusCode)) {
                    state.profileData = action.payload?.data?.data;
                    state.isSubscribed = action.payload?.data?.data?.isSubscribed || false;
                }
            })
            .addCase(getUserDetails.rejected, (state, action) => {
                // console.log("getUserDetails api error", action?.payload);
            })
            .addCase(getUserSavedCards.pending, (state, action) => {})
            .addCase(getUserSavedCards.fulfilled, (state, action) => {
                state.cards = action.payload?.data?.data?.bankDetailsList;
            })
            .addCase(getUserSavedCards.rejected, (state, action) => {
                // console.log("getUserSavedCards api error", action?.payload);
            })
            .addCase(deleteUserSavedCard.pending, (state, action) => {})
            .addCase(deleteUserSavedCard.fulfilled, (state, action) => {
                // state.cards = state.cards.filter(card => card.id !== action.payload?.data?.data?.id);
            })
            .addCase(deleteUserSavedCard.rejected, (state, action) => {
                // console.log("deleteUserSavedCard api error", action?.payload);
            })
            .addCase(saveUserCard.pending, (state, action) => {})
            .addCase(saveUserCard.fulfilled, (state, action) => {
                // state.cards.push(action.payload?.data?.data);
            })
            .addCase(saveUserCard.rejected, (state, action) => {
                console.log("saveUserCard api error", action?.payload);
            });
    },
});

export const { setUserId, setProfileData, setHelpModalRef, resetProfileSlice, setSavedCards } = profileSlice.actions;

export default profileSlice.reducer;
